"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLoadingSpinner = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledLoadingSpinner = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "LoadingSpinnerstyles__StyledLoadingSpinner",
  componentId: "lok5g5-0"
})(["animation-name:spin;animation-duration:1.5s;animation-iteration-count:infinite;animation-timing-function:linear;transform-origin:50% 50%;@keyframes spin{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}"]);
exports.StyledLoadingSpinner = StyledLoadingSpinner;